import i18n from '../plugins/i18n';
// Direct alias break i18n, proxy here we goes
const $t = function (key: any) {
  return i18n.t(key);
}

// Callback should return true is everything is okay, or text is something is broken.
// Returning false will trigger error without error message.

export const required = (v: string | undefined) => !!v || $t("validator.required");

export const fullNameRules = [
  (v: string) =>
    !v || v.length >= 6 || $t("validator.fullName.minLength"),
  (v: string) =>
    !v || /[^ ] [^ ]/.test(v) || $t("validator.fullName.minLength"),
  (v: string) =>
    !v || v.length < 32 || $t("validator.fullName.maxLength")
]

export const dateRules = [
  (v: string) => {
    const against = /^[0-9]{4,4}-[0-9]{1,2}-[0-9]{1,2}$/;
    if (v && !against.test(v)) {
      return $t("validator.invalidDate");
    }
    if (v && against.test(v) && isNaN(Date.parse(v))) {
      return $t("validator.invalidCalendarDate");
    }
    return true;
  }
]

export const postalCodeRules = [
  (v: string) => {
    if (v && !/^[1-9]{1,1}[0-9]{3,3}$/.test(v)) {
      return $t("validator.invalidPostalCode");
    }
    return true;
  }
]

export const phoneNoRules = [
  (v: string) => {
    if (v && !/^[0-9]{7,9}$/.test(v.replace(/[^0-9]/g, ''))) {
      return $t("validator.invalidPhoneNo");
    }
    return true;
  },
]

export const weightRules = [
  (v: string) => {
    if (v && !/^[1-9][0-9]{0,2}?(\.[0-9])?$/.test(v)) {
      return $t("validator.invalidWeight");
    }
    return true;
  },
]

export const inhibitorUnitRules = [
  (v: string) => {
    if (v && !/^[0-9]{0,4}$/.test(v)) {
      return $t("validator.invalidInhibitorUnit");
    }
    return true;
  },
]

export const emailRules = [
  (v: string) => {
    if (v && !/.+@.+\..+/.test(v)) {
      return $t("validator.invalidEmail");
    }
    return true;
  }
]

export const passwordRules = [
  (v: string) =>
    !v || /[A-Z]/.test(v) ||
    $t("validator.password.missingUppercase"),
  (v: string) =>
    !v || /[a-z]/.test(v) ||
    $t("validator.password.missingLowercase"),
  (v: string) =>
    !v || /[0-9]/.test(v) ||
    $t("validator.password.missingNumber"),
  (v: string) =>
    !v || /[^a-zA-Z0-9]/.test(v) ||
    $t("validator.password.missingSpecial"),
  (v: string) =>
    !v || v.length >= 8 ||
    $t("validator.password.minLength")
]
